<template>
    <div>
        <!-- 页面标题 -->
        <div class="page-header">
            <div class="line"></div>
            <div class="page-title">地址管理</div>
            <el-button type="text" class="add-address-btn" @click="openAddressDialog">
                + 新增地址
            </el-button>
        </div>

        <!-- 新增地址按钮 -->
        <div class="add-address-section">

        </div>

        <!-- 地址表格 -->
        <el-table :data="addresses" border class="address-table">
            <!-- 标签列 -->
            <el-table-column label="标签" width="100">
                <template slot-scope="scope">
                    <el-tag>
                        {{ scope.row.label_name }}
                    </el-tag>
                </template>
            </el-table-column>

            <!-- 收货人列 -->
            <el-table-column label="收货人" width="120">
                <template slot-scope="scope">{{ scope.row.real_name }}</template>
            </el-table-column>

            <!-- 联系方式列 -->
            <el-table-column label="联系方式" width="150">
                <template slot-scope="scope">{{ scope.row.mobile }}</template>
            </el-table-column>

            <!-- 地址列 -->
            <el-table-column label="地址">
                <template slot-scope="scope">{{ scope.row.province + scope.row.city + scope.row.district +
                    scope.row.detail }}</template>
            </el-table-column>

            <!-- 操作列 -->
            <el-table-column label="操作" width="220">
                <template slot-scope="scope">
                    <div class="action-buttons">
                        <el-button type="text" size="small" class="edit-btn" @click="editAddressFn(scope.row)">
                            编辑
                        </el-button>
                        <el-button type="text" size="small" class="delete-btn"
                            @click="dialogVisibleDelete = true; chooseAddress = scope.row">
                            删除
                        </el-button>
                        <el-button type="primary" size="small" plain class="default-btn"
                            @click.native="setAddressFn(scope.row)" :disabled="scope.row.is_default == 1">
                            {{ scope.row.is_default == 1 ? '默认地址' : '设置默认地址' }}
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页控件 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="totalOrders">
            </el-pagination>
        </div>


        <el-dialog title="新增收货地址" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
            <div>
                <NewAddress ref="newAddress" @addressAdded="handleAddressAdded" @close="handleClose"
                    :address="chooseAddress" :isEdit="isEdit"></NewAddress>
            </div>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span> -->
        </el-dialog>

        <el-dialog title="提示" :visible.sync="dialogVisibleDelete" width="30%" :before-close="handleClose">
            <span>是否删除该地址？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleDelete = false">取 消</el-button>
                <el-button type="primary" @click="deleteAddressFn(chooseAddress)">确 定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import NewAddress from '../../../purchase/components/NewAddress.vue'

export default {
    name: 'AddressManagement',

    components: {
        NewAddress
    },

    data() {
        return {
            // 地址数据 - 模拟实际地址数据结构
            addresses: [],
            // 分页数据
            currentPage: 1,
            pageSize: 10,
            totalOrders: 0,

            dialogVisible: false,
            dialogVisibleDelete: false,
            chooseAddress: {},

            isEdit: false

        }
    },

    watch: {
        // 监听地址列表变化
        addresses: {
            handler(newVal, oldVal) {
                this.totalOrders = newVal.length;
            },
            deep: true
        }
    },

    mounted() {
        this.getAddressList();
    },
    methods: {
        openAddressDialog() {
            this.isEdit = false
            this.chooseAddress = {}; // 重置选择的地址
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.newAddress.resetForm(); // 在对话框渲染完成后调用resetForm方法
            });
        },
        // 处理地址添加成功事件
        handleAddressAdded() {
            // 发射事件通知父组件
            this.$emit('addressListUpdated');
            // 重新获取地址列表以刷新表格数据
            this.getAddressList();
        },

        handleClose() {
            this.dialogVisible = false;
        },
        // 删除地址
        deleteAddressFn(address, index) {
            this.$dapi.deleteAddressFn({
                address_id: address.aid
            }).then(res => {
                this.$message.success('删除地址成功');
                this.$emit('addressListUpdated');
                // 重新获取地址列表以刷新表格数据
                this.getAddressList();
                this.dialogVisibleDelete = false
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 编辑地址
        editAddressFn(address) {
            console.log('打开弹窗');
            this.chooseAddress = JSON.parse(JSON.stringify(address));
            this.dialogVisible = true
            this.isEdit = true
        },
        // 设置默认地址
        setAddressFn(address, index) {
            // this.$refs.addressDialog.setAddressFn(addressId);
            console.log('设置默认地址', address);
            this.$dapi.setAddressFn({
                address_id: address.aid
            }).then(res => {
                this.$message.success('设置默认地址成功');
                this.$emit('setAddressFn', address);
                // 重新获取地址列表以刷新表格数据
                this.getAddressList();
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 获取地址列表
        getAddressList() {
            console.log('获取地址列表');
            // 这里可以实现获取地址列表的逻辑
            let data = {
                page: this.currentPage,
                list_rows: this.pageSize,
            }
            this.$api.getAddressList(data).then(res => {
                this.addresses = res.data || [];
                this.totalOrders = res.total || 0;
            }).catch(err => {
                this.$message.error(err.msg);
                console.log(err);
            })
        },

        // 分页方法
        handleSizeChange(val) {
            this.pageSize = val;
            this.getAddressList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getAddressList();
        },
    }
}
</script>

<style scoped>
/* 容器样式 */
.address-management-container {
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    margin: 0 auto;
    max-width: 1200px;
}

/* 页面标题 */
.page-header {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-left: 10px;
    text-align: left;
}

.line {
    width: 3px;
    height: 18px;
    background-color: #286CED;
}

.add-address-btn {
    /* background-color: #286CED;
    border-color: #286CED; */
    margin-left: auto;
    color: #FF9735;
    font-size: 16px;
}

/* 地址表格 */
.address-table {
    border-radius: 8px;
    overflow: hidden;
}

/* 表格操作按钮 */
.action-buttons {
    display: flex;
    /* flex-direction: column; */
    gap: 8px;
    align-items: center;
}

.edit-btn {
    color: #286CED;
}

.delete-btn {
    color: #ff4d4f;
}

.default-btn {
    border-color: #286CED;
    color: #286CED;
}

.default-btn:disabled {
    background-color: #286CED;
    color: #fff;
    border-color: #286CED;
}

/* Element UI 表格样式调整 */
::v-deep .el-table__header-wrapper th {
    background-color: #f5f7fa;
    font-weight: 600;
    color: #666;
    font-size: 14px;
}

::v-deep .el-table__body-wrapper td {
    font-size: 14px;
    color: #333;
}

::v-deep .el-table__body-wrapper tr:last-child td {
    border-bottom: none;
}

/* 分页容器 */
.pagination-container {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    text-align: right;
    text-align: center;

}

/* 响应式设计 */
@media (max-width: 768px) {
    .address-management-container {
        padding: 15px;
    }

    .add-address-section {
        text-align: left;
    }

    .action-buttons {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: center;
    }
}
</style>